<template>
  <div class="eye-contact-sliders">
    <template v-if="isNpc">
      <eye-contact-slider
        :label="'How much eye contact will ' + npcLabel + ' make with the User?'"
        :value="npcAttentionUser !== undefined ? levelsByValue[npcAttentionUser] : 3"
        :disabled="readonly"
        @change="updateNpcUserAttention"
      />
      <eye-contact-slider
        :label="'How much eye contact will ' + npcLabel + ' make with ' + patientLabel + ' ?'"
        :value="npcAttentionPatient !== undefined ? levelsByValue[npcAttentionPatient] : 3"
        :disabled="readonly"
        @change="updateNpcPatientAttention"
      />
      <eye-contact-slider
        :label="'How much eye contact will ' + patientLabel + ' make with ' + npcLabel + '?'"
        :value="patientActiveNpcAttentionType !== null ? levelsByValue[patientActiveNpcAttentionType] : 3"
        :disabled="readonly"
        @change="updatePatientNpcAttention"
      />
    </template>
    <template v-else>
      <eye-contact-slider
        :label="'How much eye contact will ' + patientLabel + ' make with the User?'"
        :value="attentionInfo.user !== undefined ? levelsByValue[attentionInfo.user] : 3"
        :disabled="readonly"
        @change="updatePatientUserAttention"
      />
    </template>
  </div>
</template>

<script>
import EyeContactSlider from './EyeContactSlider.vue';
import {
  attentionValuesByLevel as valuesByLevel,
  attentionLevelsByValue as levelsByValue,
  defaultAttentionValue
} from '../../../../lib/common/utils/attentionTypes';
import get from 'lodash/get';

export default {
  name: 'eye-tracking',
  components: { EyeContactSlider },
  props: {
    attentionInfo: {
      type: Object,
      default: () => ({}),
    },
    npc: {
      type: Object,
      default: () => ({})
    },
    isNpc: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    updateCaseConf: {
      type: Function,
      default: () => ({})
    },
    npcLabel: {
      type: String,
      default: 'the VIP'
    },
    patientLabel: {
      type: String,
      default: 'the Patient'
    }
  },
  data() {
    return {
      levelsByValue,
    };
  },
  computed: {
    patientActiveNpcAttentionType() {
      if (!this.attentionInfo.npcs) return null;
      const activeNpcAttentionInfo = this.attentionInfo.npcs.find((attentionNpc) => attentionNpc.key === this.npc.key) || {};
      return activeNpcAttentionInfo.attentionType;
    },
    patientAttentionUser() {
      return this.attentionInfo.user || defaultAttentionValue;
    },
    npcAttentionUser() {
      return get(this.npc, 'attentionInfo.user', defaultAttentionValue);
    },
    npcAttentionPatient() {
      return get(this.npc, 'attentionInfo.patient', defaultAttentionValue);
    }
  },
  methods: {
    updatePatientUserAttention(value) {
      const attentionInfo = this.attentionInfo;
      attentionInfo.user = valuesByLevel[value];
      this.updateCaseConf('attentionInfo', attentionInfo);
    },
    updatePatientNpcAttention(value) {
      const updatedAttentionType = valuesByLevel[value];
      const attentionInfo = this.attentionInfo;
      attentionInfo.user = this.patientAttentionUser;
      attentionInfo.npcs = this.attentionInfo.npcs || [];
      const existingNpcIndex = attentionInfo.npcs.findIndex((existingNpc) => existingNpc.key === this.npc.key);
      if (existingNpcIndex >= 0) {
        attentionInfo.npcs[existingNpcIndex].attentionType = updatedAttentionType;
      } else {
        attentionInfo.npcs.push({
          key: this.npc.key,
          attentionType: updatedAttentionType
        });
      }
      this.updateCaseConf('attentionInfo', attentionInfo);
    },
    updateNpcAttention(values) {
      const user = values.user || this.npcAttentionUser;
      const patient = values.patient || this.npcAttentionPatient;
      const npcAttentionInfo = {
        user,
        patient
      }
      this.updateCaseConf('attentionInfo', npcAttentionInfo, true);
    },
    updateNpcUserAttention(value) {
      const values = { user: valuesByLevel[value] };
      this.updateNpcAttention(values);
    },
    updateNpcPatientAttention(value) {
      const values = { patient: valuesByLevel[value] };
      this.updateNpcAttention(values);
    },
  },
};
</script>

<style scoped>
.eye-contact-sliders {
  width: 100%;
  padding: 10px 10px 10px 0;
}
</style>

<style>
.vue-slider-ltr .vue-slider-mark-label {
  font-size: 12px;
}
.vue-slider-mark:first-child .vue-slider-mark-step,
.vue-slider-mark:last-child .vue-slider-mark-step {
  display: block;
}
.vue-slider-mark:first-child .vue-slider-mark-step {
  left: 50%;
}
.vue-slider-mark:last-child .vue-slider-mark-step {
  left: -50%;
}
.vue-slider-ltr .vue-slider-mark:first-child .vue-slider-mark-label {
  left: 0;
  -webkit-transform: translateX(-2%);
  transform: translateX(-2%);
}
.vue-slider-ltr .vue-slider-mark:last-child .vue-slider-mark-label {
  left: 0;
  -webkit-transform: translateX(-90%);
  transform: translateX(-90%);
}
.vue-slider-ltr .vue-slider-dot[aria-valuenow="0"] {
  -webkit-transform: translate(0%, -50%) !important;
  transform: translate(0%, -50%) !important;
}

.vue-slider-ltr .vue-slider-dot[aria-valuenow="0"] .vue-slider-dot-tooltip-top {
  -webkit-transform: translate(-10%, -100%);
  transform: translate(-10%, -100%);
}
.vue-slider-ltr .vue-slider-dot[aria-valuenow="0"] .vue-slider-dot-tooltip-inner-top::after {
  left: 10%;
}

/* Assumes max value of 6 */
.vue-slider-ltr .vue-slider-dot[aria-valuenow="6"] {
  -webkit-transform: translate(-100%, -50%) !important;
  transform: translate(-100%, -50%) !important;
}

.vue-slider-ltr .vue-slider-dot[aria-valuenow="6"] .vue-slider-dot-tooltip-top {
  -webkit-transform: translate(-90%, -100%);
  transform: translate(-90%, -100%);
}
.vue-slider-ltr .vue-slider-dot[aria-valuenow="6"] .vue-slider-dot-tooltip-inner-top::after {
  left: 90%;
}
</style>
